// NOTE: HTMLのinput[type=email]と等価な正規表現を利用
// https://developer.mozilla.org/ja/docs/Web/HTML/Element/Input/email#Basic_validation

export const EmailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
